import { Text } from '@servicetitan/anvil2';
import { SetupDataStore } from '@servicetitan/financing-workflow-shared';
import { ProviderDisclosures } from '@servicetitan/financing-provider-assets';

export const Disclaimer = () => {
    const { setupData } = SetupDataStore.useStore();

    const providerName = setupData?.provider?.toLowerCase();

    const providerKey = providerName
        ? (Object.keys(ProviderDisclosures).find(key => key.toLowerCase() === providerName) as
              keyof typeof ProviderDisclosures | undefined)
        : undefined;

    const reviewDisclosure = providerKey ? ProviderDisclosures[providerKey]?.review : undefined;

    if (!reviewDisclosure || reviewDisclosure === '') {
        return null;
    }

    return (
        <div style={{ marginTop: '45px', marginBottom: '45px' }}>
            <Text variant="body" size="small" subdued>
                {reviewDisclosure}
            </Text>
        </div>
    );
};
